/* eslint-disable react/static-property-placement */
import { MODAL_TYPES } from 'Constants/modal';
import useVoidCert from 'Hooks/teleconsult/useVoidCert';
import ConfirmModal from 'Modules/ConfirmModal/ConfirmModal';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

const ConfirmReplaceMC = ({ id, data }) => {
  const { conversation, cert } = data;

  const { voidACert } = useVoidCert();
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const handleConfirm = () => {
    voidACert(cert.id);
    onClose();
    dispatch(removeModal(MODAL_TYPES.CREATE_MC));
    dispatch(
      addModal({
        type: MODAL_TYPES.MANADR_CERT,
        id: MODAL_TYPES.MANADR_CERT,
        data: {
          conversation,
          cert,
          onClose: () => {
            dispatch(removeModal(MODAL_TYPES.MANADR_CERT));
          },
        },
      }),
    );
  };

  return (
    <ConfirmModal
      showModal
      title="Replace existing MC"
      confirmButtonText="Proceed"
      onClose={onClose}
      onSubmit={handleConfirm}
      message={
        <>
          There is an existing Medical Certificate in the teleconsult. By proceeding, this MC will
          be voided. We will clone it for you to issue a new MC for patient.
        </>
      }
    />
  );
};

ConfirmReplaceMC.defaultProps = {};
ConfirmReplaceMC.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    onClose: PropTypes.func.isRequired,
    cert: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    conversation: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default ConfirmReplaceMC;
